import { useEffect, useState } from "react"

import { get_app_state } from "../../../state/store"
import { get_performant_state_reference } from "../../../state_performant_accessor"
import { asset_url } from "../../../utils/asset_url"
import { PowerType, StorageType, ValueByPowerType, ValueByStorageType } from "../../model/interface"
import { StateAtTimepoint, STORAGE_TYPES } from "../../model/v3/interface"
import pub_sub from "../../state/pub_sub"
import "./EnergySupplyDemandActions.css"


const urban_suburban_url = asset_url("/imgs/urban_suburban.png")
// const tiles_1_url = asset_url("/imgs/tiles_1.png")


const EMPTY_STATE_AT_TIMEPOINT: StateAtTimepoint = {
    timestamp_ms: 0,
    demand_GW: 0,
    by_h3r4: {},
    generated_GW_by_type: {
        battery: 0,
        gas: 0,
        hydro_river: 0,
        hydro_pumped_storage: 0,
        nuclear: 0,
        solar: 0,
        wind: 0,
    },
    stored_GWh_by_type: {
        battery: 0,
        hydro_pumped_storage: 0,
    },
    generated_GW: {
        primary: 0,
        storage: 0,
        total_positive: 0,
    },
    excess_GW: 0,
    flipflop_GW: 0,
}

export function EnergySupplyDemandActions(_props: {})
{
    const capacity_GW_by_type = get_app_state(state => state.simulation_state.sim_state?.built_power_plants.capacity_GW_by_type)
    const storage_GWh_by_type = get_app_state(state => state.simulation_state.sim_state?.built_power_plants.storage_GWh_by_type)

    const [power, set_power] = useState(EMPTY_STATE_AT_TIMEPOINT)

    useEffect(() => pub_sub.sub("simulation_datetime", () =>
    {
        const { step1, step2, step_mix } = get_performant_state_reference()
        if (!step1 || !step2) return

        const reciprocal_step_mix = 1 - step_mix
        function mix(v1: number, v2: number): number
        {
            return (v1 * reciprocal_step_mix) + (v2 * step_mix)
        }

        const power: StateAtTimepoint = {
            timestamp_ms: mix(step1.timestamp_ms, step2.timestamp_ms),
            demand_GW: mix(step1.demand_GW, step2.demand_GW),
            by_h3r4: {},

            generated_GW_by_type: {
                battery: mix(step1.generated_GW_by_type.battery, step2.generated_GW_by_type.battery),
                gas: mix(step1.generated_GW_by_type.gas, step2.generated_GW_by_type.gas),
                hydro_river: mix(step1.generated_GW_by_type.hydro_river, step2.generated_GW_by_type.hydro_river),
                hydro_pumped_storage: mix(step1.generated_GW_by_type.hydro_pumped_storage, step2.generated_GW_by_type.hydro_pumped_storage),
                nuclear: mix(step1.generated_GW_by_type.nuclear, step2.generated_GW_by_type.nuclear),
                solar: mix(step1.generated_GW_by_type.solar, step2.generated_GW_by_type.solar),
                wind: mix(step1.generated_GW_by_type.wind, step2.generated_GW_by_type.wind),
            },
            stored_GWh_by_type: {
                battery: mix(step1.stored_GWh_by_type.battery, step2.stored_GWh_by_type.battery),
                hydro_pumped_storage: mix(step1.stored_GWh_by_type.hydro_pumped_storage, step2.stored_GWh_by_type.hydro_pumped_storage),
            },
            generated_GW: {
                primary: mix(step1.generated_GW.primary, step2.generated_GW.primary),
                storage: mix(step1.generated_GW.storage, step2.generated_GW.storage),
                total_positive: mix(step1.generated_GW.total_positive, step2.generated_GW.total_positive),
            },
            excess_GW: mix(step1.excess_GW, step2.excess_GW),
            flipflop_GW: mix(step1.flipflop_GW, step2.flipflop_GW),
        }

        set_power(power)
    }))

    const diff = Math.round((power.generated_GW.primary + power.generated_GW.storage - power.demand_GW) * 10) / 10
    const sufficient_power = diff >= 0
    const diff_color = diff >= 0 ? (diff === 0 ? "grey" : "green") : "red"
    const show_capacity = true

    if (!capacity_GW_by_type || !storage_GWh_by_type) return null

    return <div
        id="energy_generated_demand_actions"
        // className="ui_section"
    >
        <table>
            <tbody>
                <tr>
                    <td/>
                    <td style={{ display: "flex", flexDirection: "column", gap: -3 }}>
                        <img src={urban_suburban_url} style={{ width: 75, marginTop: 10 }} />
                        {/* <Suburban />
                        <Urban /> */}
                    </td>
                    <td/>
                    <td/>
                    <td>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <div>
                                {power.demand_GW.toFixed(1)}
                                <span className="font_sm"> GW</span>
                            </div>
                            <span className="font_sm" style={{ marginTop: -4 }}> DEMAND</span>
                            <div style={{ color: diff_color }}>
                                {diff.toFixed(1)}
                                {/* {power.generated_GW.storage > 0 ? "+" : ""}{power.generated_GW.storage.toFixed(1)} */}
                                <span className="font_sm"> GW</span>
                            </div>
                            <span
                                className="font_sm"
                                style={{ marginTop: -4, color: diff_color }}
                            >
                                {sufficient_power ? "SURPLUS" : "SHORTAGE"}
                            </span>
                        </div>
                    </td>
                    <td/>
                    <td/>
                </tr>
                <tr>
                    <td/>
                    <td style={{ borderTop: "1px solid var(--colour-border-gray)" }}></td>
                    <td style={{ borderTop: "1px solid var(--colour-border-gray)" }}></td>
                    <td style={{ borderTop: "1px solid var(--colour-border-gray)" }}></td>
                    <td style={{ borderTop: "1px solid var(--colour-border-gray)" }}></td>
                    <td/>
                    <td/>
                </tr>
                <tr>
                    <td/>
                    <td>Wind</td>
                    <td/>
                    <td/>
                    <td><GeneratedValue capacity_GW_by_type={capacity_GW_by_type} power={power} type="wind" show_capacity={show_capacity} /></td>
                    <td/>
                    <td><BuildButton type="wind" /></td>
                </tr>
                <tr>
                    <td/>
                    <td>Solar</td>
                    <td/>
                    <td/>
                    <td><GeneratedValue capacity_GW_by_type={capacity_GW_by_type} power={power} type="solar" show_capacity={show_capacity} /></td>
                    <td/>
                    <td><BuildButton type="solar" /></td>
                </tr>
                <tr>
                    <td/>
                    <td>Nuclear</td>
                    <td/>
                    <td/>
                    <td><GeneratedValue capacity_GW_by_type={capacity_GW_by_type} power={power} type="nuclear" show_capacity={show_capacity} /></td>
                    <td/>
                    {/* <td><BuildButton type="nuclear" /></td> */}
                </tr>
                <tr>
                    <td/>
                    <td>Gas</td>
                    <td/>
                    <td/>
                    <td><GeneratedValue capacity_GW_by_type={capacity_GW_by_type} power={power} type="gas" show_capacity={show_capacity} /></td>
                    <td/>
                    {/* <td>Build</td> */}
                </tr>
                <tr>
                    <td/>
                    <td>
                        Rivers
                        {/* <span className="font_sm">(run of river)</span> */}
                    </td>
                    <td/>
                    <td/>
                    <td><GeneratedValue capacity_GW_by_type={capacity_GW_by_type} power={power} type="hydro_river" show_capacity={show_capacity} /></td>
                    <td/>
                    {/* <td>Build</td> */}
                </tr>
                <tr>
                    <td/>
                    <td className="font_sm" style={{ borderTop: "1px solid var(--colour-border-gray)" }}>
                        STORAGE
                    </td>
                    <td style={{ borderTop: "1px solid var(--colour-border-gray)" }}></td>
                    <td style={{ borderTop: "1px solid var(--colour-border-gray)" }}></td>
                    <td style={{ borderTop: "1px solid var(--colour-border-gray)" }}></td>
                    <td/>
                    <td/>
                </tr>
                <tr>
                    <td/>
                    <td>
                        Hydro
                        {/* <span className="font_sm">(pumped)</span> */}
                    </td>
                    <td/>
                    <td/>
                    <td><GeneratedValue
                        capacity_GW_by_type={capacity_GW_by_type}
                        power={power}
                        type="hydro_pumped_storage"
                        show_capacity={show_capacity}
                        storage_GWh_by_type={storage_GWh_by_type}
                    /></td>
                    <td/>
                    {/* <td>Build</td> */}
                </tr>
                <tr>
                    <td/>
                    <td>Battery</td>
                    <td/>
                    <td/>
                    <td><GeneratedValue
                        capacity_GW_by_type={capacity_GW_by_type}
                        power={power}
                        type="battery"
                        show_capacity={show_capacity}
                        storage_GWh_by_type={storage_GWh_by_type}
                    /></td>
                    <td/>
                    {/* <td>Build</td> */}
                </tr>
                <tr>
                    <td/>
                    <td className="font_sm" style={{ borderTop: "1px solid var(--colour-border-gray)" }}>
                        WASTE
                    </td>
                    <td style={{ borderTop: "1px solid var(--colour-border-gray)" }}></td>
                    <td style={{ borderTop: "1px solid var(--colour-border-gray)" }}></td>
                    <td style={{ borderTop: "1px solid var(--colour-border-gray)" }}></td>
                    <td/>
                    <td/>
                </tr>
                <tr>
                    <td/>
                    <td>Curtailed</td>
                    <td/>
                    <td/>
                    <td><GW value={power.excess_GW} /></td>
                    <td/>
                    {/* <td>Build</td> */}
                </tr>
                <tr>
                    <td/>
                    <td style={{ pointerEvents: "initial", cursor: "default" }} onClick={() => {
                        throw new Error("Testing source map included in error");
                    }}>FlipFlop</td>
                    <td/>
                    <td/>
                    <td><GW value={power.flipflop_GW} /></td>
                    <td/>
                    {/* <td>Build</td> */}
                </tr>

                {/* <tr>
                    <td/>
                    <td className="font_sm" style={{ borderTop: "1px solid var(--colour-border-gray)" }}>
                        GRID
                    </td>
                    <td style={{ borderTop: "1px solid var(--colour-border-gray)" }}></td>
                    <td/>
                    <td>Build</td>
                    </tr>
                <tr>
                    <td/>
                    <td>Electric</td>
                    <td/>
                    <td>Build</td>
                    </tr>
                <tr>
                    <td/>
                    <td>Gas</td>
                    <td/>
                    <td>Build</td>
                </tr> */}

                {/* <tr>
                    <td/>
                    <td className="font_sm" style={{ borderTop: "1px solid var(--colour-border-gray)" }}>
                        POLICY
                    </td>
                    <td style={{ borderTop: "1px solid var(--colour-border-gray)" }}></td>
                    <td/>
                    <td>Build</td>
                    </tr>
                <tr>
                    <td/>
                    <td>Pricing</td>
                    <td className="font_sm">National</td>
                    <td/>
                    <td>Build</td>
                    </tr>
                <tr>
                    <td/>
                    <td>Oil & Gas</td>
                    <td/>
                    <td>Build</td>
                </tr> */}
            </tbody>
        </table>
    </div>
}


interface GeneratedValueProps
{
    capacity_GW_by_type: ValueByPowerType<number>
    power: StateAtTimepoint
    type: PowerType
    show_capacity: boolean
    storage_GWh_by_type?: ValueByStorageType<number>
}
function GeneratedValue(props: GeneratedValueProps)
{
    const { capacity_GW_by_type, power, type, show_capacity } = props
    const generated_GW = power.generated_GW_by_type[type]
    const capacity_GW = capacity_GW_by_type[type]

    function is_storage_type(t: PowerType): t is StorageType
    {
        return (STORAGE_TYPES as readonly string[]).includes(t as unknown as string)
    }

    return <>
        <GW value={generated_GW} capacity={show_capacity ? capacity_GW : undefined} />

        {is_storage_type(type) && props.storage_GWh_by_type?.[type] !== undefined &&
            <GWhWithStorage value={power.stored_GWh_by_type[type]} capacity={props.storage_GWh_by_type[type]}
        />}
    </>
}


function GW(props: { value: number, capacity?: number })
{
    const { value, capacity } = props

    if (capacity !== undefined) return <>
        {value.toFixed(1)} / {capacity.toFixed(1)}
    </>

    return <>{value.toFixed(1)}</>
}


function GWhWithStorage(props: { value: number, capacity?: number })
{
    const { value, capacity } = props

    if (capacity !== undefined) return <>
        {" | "}{value.toFixed(1)} / {capacity.toFixed(1)} GWh
    </>

    return <>
        {" | "}{value.toFixed(1)} GWh
    </>
}


// function Suburban()
// {
//     return <img src={tiles_1_url} style={{
//         width: 70,
//         height: 50,
//         objectFit: "cover",
//         objectPosition: "0px -140px",
//         // marginLeft: -10,
//     }} />
// }

// function Urban()
// {
//     return <img src={tiles_1_url} style={{
//         width: 70,
//         height: 50,
//         objectFit: "cover",
//         objectPosition: "0px -185px",
//         marginTop: -10,
//         // marginRight: -10,
//     }} />
// }


function BuildButton(props: { type: PowerType })
{
    const current_action = get_app_state(state => state.building_action.active)
    const set_building_action = get_app_state(state => state.building_action.set_building_action)
    const set_map_capacity_factors = get_app_state(state => state.view.set_map_capacity_factors)
    const is_current_action = current_action && current_action?.type === props.type

    return <button
        className={"ui_button " + (is_current_action ? "active" : "")}
        onClick={() =>
        {
            set_building_action(is_current_action ? false : { type: props.type })
            if ((props.type === "wind" || props.type === "solar") && !is_current_action)
            {
                set_map_capacity_factors(props.type)
            }
            else set_map_capacity_factors(false)
        }}
    >
        Build
    </button>
}
